export class HttpResponseError extends Error {
    response?: Response;

    resolvedResponseBody?: any;
}

export class XMLHttpRequestError extends Error {
    response?: Response | string;

    contentType?: string | null;

    server?: string | null;
}
